const prodNweaConfig = {
  name: 'prod',
  rootUrl: 'https://platform.heinemann.com/ui/',
  loginUrl: 'https://platform.heinemann.com/ui/login/',
  loggedInUrl: 'https://platform.heinemann.com/ui/logged-in/',
  loggedOutUrl: 'https://platform.heinemann.com/ui/login/logged-out/',
  helpUrl: 'https://connection.nwea.org/s/support?language=en_US',
  privacyPolicyUrl: 'https://www.nwea.org/policy/privacy-and-terms/',
  termsAndConditionsUrl:
    'https://www.nwea.org/policy/nwea-platform-terms-of-use/',
  forgotPasswordUrlPath: '/ui/login/forgot-password/',
  requestSigninDetailsUrlPath: '/ui/login/request-signin-details/',
  restIdsGridApi: 'https://papi.hmhco.com/ids-grid-api',
  hcpIdentityApiGateway: 'https://papi.hmhco.com/hcp-identity-api-gateway',
  edsAuthorizationCode:
    'https://hapi.hmhco.com/edcore/eds-login/login/authorization-code/callback',
  susAuth: 'https://www.hmhco.com/api/authorization',
  authorizationApi: 'https://www.hmhco.com/api/authorization',
  edsInitUrl: 'https://hapi.hmhco.com/edcore/eds-login/login/initializeUri',
};

module.exports = prodNweaConfig;
